// src/pages/HomePage.tsx
import React from "react";
import { FaCheck, FaUserFriends, FaDatabase, FaArrowRight } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../Styles/HomePage.css";

const HomePage: React.FC = () => {
  return (
    <div className="home-container">
      

      <main>
        {/* Updated Hero Section */}
      <section className="hero">
  <div className="hero-overlay"></div>

  <div className="hero-content">
    <div className="text-content">
      <h1>
        Revolutionizing Medical Imaging:
        <span>Clarity, Accessibility, Impact.</span>
      </h1>
      <p className="subtitle">
        DigiRay empowers precise diagnostics through intuitive X‑ray
        uploads and a comprehensive public database.
      </p>
      <div className="cta-buttons">
        <button className="primary-btn">Search Your X‑ray</button>
        <button className="secondary-btn">Digital Public Database</button>
      </div>
    </div>
  </div>
</section>


        <section className="about">
          <div className="about-content">
            <div className="about-image">
              <div className="image-bg"></div>
              <div className="image-overlay-text">
                Medical Imaging Visualization
              </div>
            </div>

            <div className="text-content">
              <h2>About DigiRay</h2>
              <p>
                DigiRay is at the forefront of medical imaging technology,
                designed to simplify the complex process of X-ray analysis and
                sharing. Our platform offers a secure, intuitive environment for
                both medical professionals and the public to interact with
                diagnostic images. We prioritize data integrity, user privacy,
                and fostering a collaborative community to advance healthcare
                through accessible imaging insights.
              </p>

              <div className="about-stats">
                <div className="stat-item">
                  <div className="stat-number">99.7%</div>
                  <div className="stat-label">Accuracy Rate</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">5,000+</div>
                  <div className="stat-label">Medical Partners</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Support</div>
                </div>
              </div>
            </div>
          </div>
        </section>

      <section className="features">
  <h2>Key Features That Set Us Apart</h2>
  <div className="features-grid">
    {/* Feature 1 */}
    <div className="feature-card">
      <div className="feature-icon">
        <svg viewBox="0 0 24 24">
          <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
        </svg>
      </div>
      <h3>Intuitive Uploads</h3>
      <p>Upload X-ray images with our drag-and-drop interface, ensuring quick and secure data submissions.</p>
    </div>
    
    {/* Feature 2 */}
    <div className="feature-card">
      <div className="feature-icon">
        <svg viewBox="0 0 24 24">
          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
        </svg>
      </div>
      <h3>Secure & Anonymous</h3>
      <p>Your data privacy is paramount. We ensure anonymous submissions and secure handling of all images.</p>
    </div>
    
    {/* Feature 3 */}
    <div className="feature-card">
      <div className="feature-icon">
        <svg viewBox="0 0 24 24">
          <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"/>
        </svg>
      </div>
      <h3>Public Database Access</h3>
      <p>Explore a vast, anonymized database of medical images for research and educational purposes.</p>
    </div>
    
    {/* Feature 4 */}
    <div className="feature-card">
      <div className="feature-icon">
        <svg viewBox="0 0 24 24">
          <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"/>
        </svg>
      </div>
      <h3>Direct Feedback Channel</h3>
      <p>Share your thoughts directly through our integrated feedback system to help us improve.</p>
    </div>
    
    {/* Feature 5 */}
    <div className="feature-card">
      <div className="feature-icon">
        <svg viewBox="0 0 24 24">
          <path d="M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92a9 9 0 00-9-9c-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8A8.964 8.964 0 003 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L2.92 2.29zM12 20c-3.87 0-7-3.13-7-7 0-1.12.27-2.18.74-3.12l9.38 9.38c-.94.47-2 .74-3.12.74z"/>
        </svg>
      </div>
      <h3>Accurate Diagnostics</h3>
      <p>Advanced AI algorithms provide preliminary diagnostic insights to support medical professionals.</p>
    </div>
    
    {/* Feature 6 */}
    <div className="feature-card">
      <div className="feature-icon">
        <svg viewBox="0 0 24 24">
          <path d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1a6.875 6.875 0 000 9.79c2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58a8.987 8.987 0 0112.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"/>
        </svg>
      </div>
      <h3>Continuous Improvement</h3>
      <p>We constantly enhance features based on user feedback and medical advancements.</p>
    </div>
  </div>
</section>

         {/* Modern MedImager Section */}
        <section className="medimager-section">
          <div className="medimager-content">
            <div className="medimager-left">
              <h2>Why Choose DigiRay?</h2>
              <ul className="features-list">
                <li className="feature-item">
                  <div className="feature-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                  </div>
                  <div className="feature-text">
                    <h3>Unparalleled Accuracy</h3>
                    <p>AI-powered analysis for precise diagnostics</p>
                  </div>
                </li>
                <li className="feature-item">
                  <div className="feature-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                  </div>
                  <div className="feature-text">
                    <h3>Globally Trusted</h3>
                    <p>Trusted by medical professionals worldwide</p>
                  </div>
                </li>
                <li className="feature-item">
                  <div className="feature-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                  </div>
                  <div className="feature-text">
                    <h3>Largest Public Database</h3>
                    <p>For research and education</p>
                  </div>
                </li>
                <li className="feature-item">
                  <div className="feature-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                    </svg>
                  </div>
                  <div className="feature-text">
                    <h3>Industry-Leading Security</h3>
                    <p>Privacy protocols to protect sensitive data</p>
                  </div>
                </li>
              </ul>
            </div>
            
            <div className="divider"></div>
            
            <div className="medimager-right">
              <h2>Join Our Growing Community!</h2>
              <p className="community-subtitle">
                Explore thousands of anonymized X-ray images, contribute to medical research, 
                and advance your diagnostic skills.
              </p>
              
              <div className="stats-container">
                <div className="stat-card">
                  <div className="stat-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                    </svg>
                  </div>
                  <div className="stat-value">100K+</div>
                  <div className="stat-label">Active Users</div>
                </div>
                
                <div className="stat-card">
                  <div className="stat-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 10H6v-2h8v2zm4-4H6v-2h12v2z"/>
                    </svg>
                  </div>
                  <div className="stat-value">20M+</div>
                  <div className="stat-label">Images Uploaded</div>
                </div>
              </div>
              
              <button className="explore-button">
                Explore Database Now 
                <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
                </svg>
              </button>
            </div>
          </div>
        </section>
      </main>

 
    </div>
  );
};

export default HomePage;